import React from 'react';

interface ESSConfigProps {
  onClose: () => void;
  loading: boolean;
  configData: any;
}

const DISPLAY_KEYS = ['eventGroup', 'status', 'userId'];

const ESSConfig: React.FC<ESSConfigProps> = ({ onClose, loading, configData }) => {
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" style={{ minWidth: 600, maxWidth: 900 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>ESS Subscriptions</h2>
          <button onClick={onClose} className="close-btn" aria-label="Close">✖️</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div>Loading...</div>
          ) : !configData || (Array.isArray(configData) && configData.length === 0) ? (
            <div>No ESS subscriptions found.</div>
          ) : (
            <table className="ess-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: '#f9fafb', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
              <thead>
              <tr>
                {DISPLAY_KEYS.map((key) => (
                  <th key={key} style={{ borderBottom: '2px solid #e0e0e0', textAlign: 'left', padding: '10px 12px', background: '#f1f3f6', fontWeight: 600 }}>{key}</th>
                ))}
              </tr>
              </thead>
              <tbody>
              {configData.map((sub: any, idx: number) => (
                <tr key={idx} className="ess-row">
                  {DISPLAY_KEYS.map((key) => (
                    <td key={key} style={{ borderBottom: '1px solid #ececec', padding: '10px 12px' }}>
                      {typeof sub[key] === 'object' && sub[key] !== null
                        ? <pre style={{ margin: 0, fontSize: '0.98em', fontFamily: 'monospace', background: '#f4f4f4', borderRadius: 4, padding: '4px 8px' }}>
                            {JSON.stringify(sub[key], null, 2)}
                          </pre>
                        : String(sub[key] ?? '')}
                    </td>
                  ))}
                </tr>
              ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <style>{`
        .modal-overlay {
          position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; z-index: 1000;
        }
        .modal-content {
          background: #fff; border-radius: 16px; box-shadow: 0 4px 24px rgba(0,0,0,0.18); padding: 2.5rem 2rem; position: relative;
          transition: box-shadow 0.2s;
        }
        .modal-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem; }
        .close-btn { background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #888; transition: color 0.2s; }
        .close-btn:hover { color: #222; }
        .modal-body { margin-top: 0; }
        .ess-table th, .ess-table td { font-size: 1.05rem; }
        .ess-row:hover td { background: #f0f6ff; transition: background 0.2s; }
      `}</style>
    </div>
  );
};

export default ESSConfig;
